'use client';

import React, { createContext, useContext, useEffect } from 'react';

// Karena hanya ada satu tema, kita kunci ke 'light'
interface ThemeContextValue {
  theme: 'light';
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: 'light',
  toggleTheme: () => {}, // Fungsi kosong karena tidak ada lagi yang perlu diubah
});

export function useTheme() {
  return useContext(ThemeContext);
}

export default function ThemeProvider({ children }: { children: React.ReactNode }) {
  
  useEffect(() => {
    // 1. Pastikan class 'dark' dihapus dari sistem root (html)
    document.documentElement.classList.remove('dark');
    
    // 2. Set gaya warna sistem browser agar selalu light (untuk scrollbar dll)
    document.documentElement.style.colorScheme = 'light';
    
    // 3. Bersihkan data tema lama agar tidak bentrok di masa depan
    localStorage.removeItem('indocutting-theme');
  }, []);

  const toggleTheme = () => {
    // Tidak melakukan apa-apa jika tombol toggle ditekan
    console.log("Website dikunci pada mode terang.");
  };

  return (
    <ThemeContext.Provider value={{ theme: 'light', toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}